
export default class SwClassAfter extends ContaoWebpack.Plugin {
	init () {
        this.options = {...{
            scrolling: [],
        }, ...this.options};


        this.setupClasses();

        document.addEventListener("scroll", () => {
            this.setupClasses();
        });
	}

    setupClasses() {
        this.options.scrolling.forEach((settings) => {
            if (settings.after !== undefined) {
                let element = document.querySelector(settings.after),
                    offsetY = settings.offsetY||0;
                if (element === null) {
                    return;
                }

                if ((element.getBoundingClientRect().bottom + offsetY) <= 0) {
                    this.addClasses(settings);
                    return;
                }

                this.removeClasses(settings);
            }
        });
    }

    addClasses(settings) {
        let classNames = settings.class.split(' '),
            setup = true;

        classNames.forEach((className) => {
            if (this.el.classList.contains(className)) {
                setup = false;
            }
        });

        if (!setup) {
            return;
        }

        this.el.classList.add(settings.class);
    }

    removeClasses(settings) {
        let classNames = settings.class.split(' ');
        classNames.forEach((className) => {
            this.el.classList.remove(className);
        });
    }
}
